import * as React from 'react';
import { connect } from 'react-redux';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { Field } from '@progress/kendo-react-form';
import { FormPage, TextBox, TextArea, DatePicker } from '../../../ui';
import {
  loadEventFormPage,
  saveEvent,
  cancelEventFormPage
} from '../actions/event-form-page-actions';
import { withRouter } from '../../../components/withRouter';

class GeneralCompetencyEventFormPage extends React.PureComponent {

  constructor() {
    super();
    this.handleValidate = this.handleValidate.bind(this);
    this.handleBreadcrumbItemClick = this.handleBreadcrumbItemClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  async componentDidMount() {
    await this.props.loadEventFormPage({ eventId: this.props.params.generalCompetencyEventId });
  }

  componentWillUnmount() {
    this.props.cancelEventFormPage();
  }

  render() {
    const localizationService = provideLocalizationService(this);
    return (
      <FormPage
        title={localizationService.toLanguageString('generalCompetencyEvent.formTitle')}
        breadcrumbItems={[
          {
            id: 'general_competency_events',
            text: localizationService.toLanguageString('generalCompetencyEvent.listTitle')
          },
          {
            id: 'general_competency_event',
            text: localizationService.toLanguageString('generalCompetencyEvent.formTitle'),
            disabled: true
          }
        ]}
        onBreadcrumbItemClick={this.handleBreadcrumbItemClick}
        onBackClick={this.handleBackClick}
        renderBackButton={true}
        validationResult={this.props.validationResult}
        loading={this.props.loading}
        initialValues={this.props.event}
        localizationService={localizationService}
        onSubmit={this.handleSubmit}
        onCancel={this.handleCancel}
        validator={this.handleValidate}
        render={() => (
          <>
            <Field
              name='name'
              label={localizationService.toLanguageString('generalCompetencyEvent.name')}
              component={TextBox}
              width='320px'
            />
            <Field
              name='description'
              label={localizationService.toLanguageString('generalCompetencyEvent.description')}
              id='description'
              component={TextArea}
              autoSize={true}
              width='320px'
            />
            <Field
              name='startDate'
              label={localizationService.toLanguageString('generalCompetencyEvent.startDate')}
              component={DatePicker}
              width='320px'
            />
            <Field
              name='endDate'
              label={localizationService.toLanguageString('generalCompetencyEvent.endDate')}
              component={DatePicker}
              width='320px'
            />
          </>
        )}
      />
    );
  }

  handleValidate(values, localizationService, validationResult, modified) {
    const errors = {};
    const maxNameLength = 500;
    const maxDescriptionLength = 5000;
    if (!values.name) {
      errors.name = localizationService.toLanguageString('validation.required');
    } else if (values.name.length > maxNameLength) {
      errors.name = `${localizationService.toLanguageString('validation.exceedsMaximumLength')}(${maxNameLength})`;
    }
    if (values.description && values.description.length > maxDescriptionLength) {
      errors.description = `${localizationService.toLanguageString('validation.exceedsMaximumLength')}(${maxDescriptionLength})`;
    }
    if (!values.startDate) {
      errors.startDate = localizationService.toLanguageString('validation.required');
    }
    if (!values.endDate) {
      errors.endDate = localizationService.toLanguageString('validation.required');
    }
    if (values.startDate && values.endDate && values.endDate < values.startDate) {
      errors.endDate = localizationService.toLanguageString('validation.endDateMustNotBeEarlierThanStartDate');
    }
    if (!modified.name && !modified.description) {
      if (validationResult?.errors?.name) {
        errors.name = validationResult?.errors?.name;
      }
      if (validationResult?.errors?.description) {
        errors.description = validationResult?.errors?.description;
      }
    }
    return errors;
  }

  handleBreadcrumbItemClick(e) {
    if (e.id === 'general_competency_events') {
      this.props.navigate('/general_competency_events');
    }
  }

  handleBackClick() {
    this.props.navigate(-1);
  }

  handleCancel() {
    this.props.navigate(-1);
  }

  handleSubmit(payload) {
    this.props.saveEvent(payload);
  }
}

registerForLocalization(GeneralCompetencyEventFormPage);

const mapStateToProps = state => ({
  loading: state.generalCompetencyEventFormPage.loading,
  event: state.generalCompetencyEventFormPage.event,
  validationResult: state.generalCompetencyEventFormPage.validationResult
});

const mapDispatchToProps = dispatch => ({
  loadEventFormPage: (payload) => dispatch(loadEventFormPage(payload)),
  saveEvent: (payload) => dispatch(saveEvent(payload)),
  cancelEventFormPage: () => dispatch(cancelEventFormPage())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(GeneralCompetencyEventFormPage));
